import { Injectable } from '@angular/core';

import { WageBase } from '../../models/wage-base';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class WageBaseService {
  private url: string = 'wage_bases';

  constructor(private httpClient: HttpClientService) {}

  delete(id: number): Promise<any> {
    return this.httpClient.delete(`${this.url}/${id}.json`);
  }

  edit(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}/edit.json`);
  }

  get(id: any): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}.json`);
  }

  index(params: any = {}) {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  save(wageBase: WageBase): Promise<any> {
    if (wageBase.id) return this.httpClient.put(`${this.url}/${wageBase.id}.json`, { wage_base: wageBase });
    else return this.httpClient.post(`${this.url}.json`, { wage_base: wageBase });
  }
}
